module.exports = __webpack_public_path__ + "static/media/search (3).b319a4ec.png";